<template>
    <div class="BottomContent">
        <div v-for="(v, i) in listData" :key="i"
            :style="{ height: listData.length === 1 ? '100%' : '', width: listData.length === 1 ? '100%' : '' }">
            <div class="name">{{ v.name }}</div>
            <div class="value">{{ v.value1 }}</div>
            <div v-if="!!v?.value2" class="value">{{ v.value2 }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomContent",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
    },
    components: {},
    data() {
        return {}
    },
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.BottomContent {
    width: 100%;
    height: 100%;
    @include setFlexBetween;
    flex-wrap: wrap;
    color: #fff;

    &>div {
        width: 32%;
        height: 80px;
        border-radius: 4px;
        border: 2px solid #0C859F;
        @include setFlexColumn;
        justify-content: center;
        align-items: center;

        .name {
            height: 16px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #C9CCD6;
            line-height: 16px;
        }

        .value {
            margin-top: 2px;
            height: 18px;
            font-size: 15px;
            font-family: SourceHanSansSC-Medium, SourceHanSansSC;
            font-weight: 500;
            color: #16E9F4;
            line-height: 18px;
        }

    }
}
</style>